import { FC } from "react";

import "./Flag.scss";
import { FlagType } from "./Types";

const Flag: FC<FlagType> = ({ ico, text }) => {
  return (
    <div className="flag box">
      <div className="flag__content">
        {ico && <img src={ico} alt="flag" className="flag__ico" />}
        <p className="flag__text">{text}</p>
      </div>
    </div>
  );
};

export default Flag;
